import { esSnapshot } from "./renglones";

/**
 * Cómo se muestra una consulta ya guardada.
 *
 * Aparte de la pantalla porque son reglas con bordes —el importe fijo, el
 * renglón sin cotizar, el snapshot que no tiene la forma esperada— y una
 * pantalla no se puede poner en un test sin un browser.
 */

/**
 * Importes en pesos. Se re-exporta desde `lib/formato` para no romper a los seis
 * consumidores que ya lo importan desde acá.
 */
export { pesos } from "../../lib/formato";

/**
 * El importe de un renglón ya guardado, o `null` si todavía no se cotizó.
 *
 * **El snapshot manda y no se recalcula.** Ya trae el `total` con la regla de
 * `esImporteFijo` aplicada por el worker (ADR 0012); multiplicarlo acá por la
 * cantidad convertiría un diseño de $9.000 cobrado una sola vez en $450.000
 * para una tirada de 50. Es el mismo razonamiento que `subtotalRenglon`, sobre
 * la forma que tiene el renglón cuando vuelve de la base.
 *
 * Sin snapshot el precio se cargó a mano, y ahí sí se multiplica.
 */
export function subtotalDeItemGuardado(item: {
  cantidad: number;
  precioUnitario: string | null;
  precioSnapshot: unknown;
}): number | null {
  if (esSnapshot(item.precioSnapshot)) {
    const total = Number(item.precioSnapshot.total);
    if (Number.isFinite(total)) return total;
  }
  if (item.precioUnitario === null) return null;
  const unitario = Number(item.precioUnitario);
  return Number.isFinite(unitario) ? unitario * item.cantidad : null;
}

/**
 * OTs vivas bajo un presupuesto `CANCELADO`: solo existen por un salto forzado
 * (ADR 0098). El detalle las marca para que no pasen inadvertidas.
 */
export function otsVivasBajoCancelado<T extends { estado: string }>(
  estadoPresupuesto: string,
  producciones: readonly T[],
): T[] {
  if (estadoPresupuesto !== "CANCELADO") return [];
  return producciones.filter((o) => o.estado !== "CANCELADA" && o.estado !== "ELIMINADA");
}
